import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IMarketDataLookupRequest, IMarketDataLookupResponse, IPartLookupResponse } from "../models/PartLookup";
import { IVehicle } from "../models/Vehicle";
import useVehicleSingle from "./useVehicleSingle";
import { DefaultResponseWithData } from './../models/system';

export default function usePartsMarketDataLookup(vehicleId: string | undefined, make?: string, model?: string, year?: number, enabled: boolean = true) {
  const { get, post, put } = useApiHelper();
  const { vehicle: singleVehicle } = useVehicleSingle(vehicleId);
  const queryClient = useQueryClient();
  const staleTime = 1000 * 60 * 60; // 60 minutes

  const lookupReq: IMarketDataLookupRequest = {
    make: make ?? singleVehicle.data?.data.combinedMake,
    model: model ?? singleVehicle.data?.data.modelRangeDescription,
    year: year ?? singleVehicle.data?.data.dvlaYearOfManufacture,
  }

  const marketData = useQuery({
    queryKey: ["marketData", "vehicle", vehicleId, lookupReq.make, lookupReq.model, lookupReq.year],
    queryFn: () => post<IMarketDataLookupRequest, DefaultResponseWithData<IMarketDataLookupResponse>>(`/partlookup/lookup/market-data`, lookupReq),
    staleTime: staleTime,
    enabled: enabled && !!lookupReq.make && !!lookupReq.model && !!lookupReq.year,
  });

  return {
    marketData,
  };
}
